module.exports = __webpack_public_path__ + "assets/media/findteam.f7a82cb2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/findteam.svg
// module id = 3189
// module chunks = 0